const Footer = () => {
	return (
		<footer className="wrapper">
			Made by Gabriel Wright at Juno College (2022)
		</footer>
	);
};
export default Footer;
